import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import {contractFromApi} from './reducer';

export const fetchContract = (contractId, token) =>
    RESTClient.getObservable(`v2/contract/${contractId}`, {token}).map(response => contractFromApi(response.contract));

export const acceptContract = (contractId, token) => RESTClient.postObservable(`v2/contract/${contractId}`, {token});
